type Props = React.SVGProps<SVGSVGElement> & {
  size?: number;
  className?: string;
};

export function MaterialQuickReferenceAll(props: Props) {
  const size = props.size ?? 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="currentColor"
      viewBox="0 0 16 16"
      {...props}
    >
      <mask
        id="a"
        width={16}
        height={16}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path fill="currentColor" d="M0 0h16v16H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="currentColor"
          strokeWidth="1"
          d="M3.33333 2.66671V6.68337V6.66671V13.3334V2.66671ZM4.66667 9.33337H7C7.1 9.07782 7.22222 8.83893 7.36667 8.61671C7.51111 8.39449 7.67778 8.18893 7.86667 8.00004H4.66667V9.33337ZM4.66667 12H6.78333C6.72778 11.7778 6.69167 11.5556 6.675 11.3334C6.65833 11.1112 6.66111 10.8889 6.68333 10.6667H4.66667V12ZM3.33333 14.6667C2.96667 14.6667 2.65278 14.5362 2.39167 14.275C2.13056 14.0139 2 13.7 2 13.3334V2.66671C2 2.30004 2.13056 1.98615 2.39167 1.72504C2.65278 1.46393 2.96667 1.33337 3.33333 1.33337H8.66667L12.6667 5.33337V7.00004C12.4556 6.91115 12.2389 6.84171 12.0167 6.79171C11.7944 6.74171 11.5667 6.7056 11.3333 6.68337V6.00004H8V2.66671H3.33333V13.3334H7.35C7.52778 13.6 7.72778 13.8473 7.95 14.075C8.17222 14.3028 8.41667 14.5 8.68333 14.6667H3.33333ZM11 12.6667C11.4667 12.6667 11.8611 12.5056 12.1833 12.1834C12.5056 11.8612 12.6667 11.4667 12.6667 11C12.6667 10.5334 12.5056 10.1389 12.1833 9.81671C11.8611 9.49449 11.4667 9.33337 11 9.33337C10.5333 9.33337 10.1389 9.49449 9.81667 9.81671C9.49444 10.1389 9.33333 10.5334 9.33333 11C9.33333 11.4667 9.49444 11.8612 9.81667 12.1834C10.1389 12.5056 10.5333 12.6667 11 12.6667ZM14.4 15.3334L12.6 13.5334C12.3667 13.6889 12.1139 13.8056 11.8417 13.8834C11.5694 13.9612 11.2889 14 11 14C10.1667 14 9.45833 13.7084 8.875 13.125C8.29167 12.5417 8 11.8334 8 11C8 10.1667 8.29167 9.45837 8.875 8.87504C9.45833 8.29171 10.1667 8.00004 11 8.00004C11.8333 8.00004 12.5417 8.29171 13.125 8.87504C13.7083 9.45837 14 10.1667 14 11C14 11.2889 13.9611 11.5695 13.8833 11.8417C13.8056 12.1139 13.6889 12.3667 13.5333 12.6L15.3333 14.4L14.4 15.3334Z"
        />
      </g>
    </svg>
  );
}
